var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{staticClass:"vlp-custom-icon",attrs:{"viewBox":"0 0 32 32","aria-hidden":"true"}},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":("#icon-" + (_vm.props.icon))}})])}
var staticRenderFns = []

export { render, staticRenderFns }